/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCarGarage = createReactComponent("outline", "car-garage", "IconCarGarage", [["path", { "d": "M5 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M15 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 20h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5", "key": "svg-2" }], ["path", { "d": "M3 6l9 -4l9 4", "key": "svg-3" }]]);

export { IconCarGarage as default };
//# sourceMappingURL=IconCarGarage.mjs.map
